import type { TreeNodeDefinition } from '@trimble/ui-components/solidjs';

import type { FxWorkspaceTreeItem } from './fx-workspace-tree.types';

export type FxReferencesViewMode = 'tree' | 'flat';

function isIntermediateReferenceKind(
  kind: FxWorkspaceTreeItem['kind'] | undefined
): boolean {
  return (
    kind === 'referenceCategory' ||
    kind === 'referenceMission' ||
    kind === 'referenceRuns' ||
    kind === 'referenceFolder'
  );
}

export function flattenFxReferenceNodes(
  nodes: TreeNodeDefinition<FxWorkspaceTreeItem>[]
): TreeNodeDefinition<FxWorkspaceTreeItem>[] {
  return nodes.flatMap((node) => {
    const kind = node.data?.kind;
    if (kind === 'references' || isIntermediateReferenceKind(kind)) {
      return [];
    }

    if (kind === 'reference') {
      // A map workspace row is a saveable reference and a parent of layers.
      // Flat view keeps the layers and drops that empty parent.
      if (node.isLeaf === false) {
        return [];
      }

      return [{ ...node, parentId: undefined }];
    }

    return [node];
  });
}
